import type { Client } from '@/api/user/getCurrentUser.ts';

export const filterClientsByTerm =
  (searchTerm: string) =>
  (client: Client): boolean =>
    [client.companyName, client.companyId.toString(), client.externalCompanyName].some((field) =>
      field?.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()),
    );

export const sortClientsByCompanyName = (clientA: Client, clientB: Client): number => {
  return clientA.companyName.localeCompare(clientB.companyName);
};

export const sortClientsByPinIndex =
  (pinnedCompaniesIds: number[]) =>
  (clientA: Client, clientB: Client): number => {
    const indexA = pinnedCompaniesIds.indexOf(clientA.companyId);
    const indexB = pinnedCompaniesIds.indexOf(clientB.companyId);
    if (indexA === -1) {
      return -1;
    }
    if (indexB === -1) {
      return 1;
    }
    return indexA - indexB;
  };

export function partitionByPinState(clients: Client[], pinnedCompanies: number[], defaultCompanyId: number) {
  return clients.reduceRight<[pinned: Client[], regular: Client[]]>(
    (partitions, client) => {
      if (client.companyId !== defaultCompanyId) {
        // skip default client (always displayed on top of the list)
        partitions[pinnedCompanies.includes(client.companyId) ? 0 : 1].push(client);
      }
      return partitions;
    },
    [[], []],
  );
}
